import React from 'react';
import { Tabs, Menu, Dropdown, Button, Icon } from 'antd';
import GraphTopTrackers from '../../components/GraphTopTrackers'
import GraphSkillsLogged from '../../components/GraphSkillsLogged'
import CompareTool from '../../components/CompareTool'
const TabPane = Tabs.TabPane;

class GeneralInfoRender extends React.Component {

  state = {
    category: "All",
    cluster: "All",
// skill: "All"
  }

  setFilter = (filterBy, translated, selected) => {
    if (filterBy == 'category') {
      this.setState({category: translated, cluster: 'All'})
      this.props.setFilter(filterBy, selected)
      this.props.setFilter('cluster', 'All')
    } else if (filterBy == 'cluster') {
      this.setState({cluster: translated})
      this.props.setFilter(filterBy, selected)
    } else {
      this.setState({skill: translated})
      this.props.setFilter(filterBy, selected)
    }

  }

  menuCategory = () => {
    const t = this.props.t;
    const categories = this.props.category
    return (
      <Menu style={styles.dropdown} onClick={(e) => this.setFilter('category', e.item.props.children, e.key)}>
        <Menu.Item key="all">{t('All')}</Menu.Item>
        {categories && categories.map( (category, i) =>
          <Menu.Item key={category[1].name}>{t(category[1].name)}</Menu.Item>
          )
        }
      </Menu>
    )
  }

  menuCluster = () => {
    const t = this.props.t;
    const clusters = this.props.cluster
    return (
      <Menu style={styles.dropdown} onClick={(e) => this.setFilter('cluster', e.item.props.children, e.key)}>
        <Menu.Item key="all">{t('All')}</Menu.Item>
        {clusters && clusters.map( (cluster, i) =>
          <Menu.Item key={cluster[1].name}>{t(cluster[1].name)}</Menu.Item>
          )
        }
      </Menu>
    )
  }

  // menuSkill = () => {
  //   const { t } = this.props.t;
  //   const skills = this.props.skill
  //   return (
  //     <Menu style={styles.dropdown} onClick={(e) => this.setFilter('skill', e.item.props.children)}>
  //       <Menu.Item key="all">{t('All')}</Menu.Item>
  //       {skills && skills.map( (skill, i) =>
  //         <Menu.Item key={i}>{t(skill)}</Menu.Item>
  //         )
  //       }
  //     </Menu>
  //   )
  // }

  render() {
    const categories = this.props.category
    const { t, currentYear, allYears, gradeSelected } = this.props
    const yearTabs = gradeSelected ? [{text: 'Selected class'}] : allYears

    return (
      <div>
        <div style={styles.container} className="card-container toptrackers" id="yeartabs">
          <Tabs
            type="card"
            activeKey={currentYear.year && !gradeSelected  ? currentYear.year.text : 'Selected class'}
            onTabClick={(year) => !gradeSelected && this.props.changeYear(allYears.filter( item => item.text === year)[0])}
          >
          {yearTabs && yearTabs.map( year => (
            <TabPane
              style={styles.yearbox}
              tab={year.text}
              key={year.text}
            >
              <div style={styles.logged}>
                <p>{this.props.logsCount}</p>
                <p>{this.props.logsCount > 1 ? t('Tasks Logged') : t('Task Logged')}</p>
              </div>
              <GraphTopTrackers t={this.props.t} data={this.props.toptrackers}/>
            </TabPane>
          ))}
          </Tabs>
        </div>
        <div id='amountskills' style={styles.container2}>
          <p style={styles.paragraph}>{t('Amount of skills logged over time')}</p>
          <div style={{paddingLeft: '40px', marginBottom: 20}}>
            <Dropdown overlay={this.menuCategory()}>
              <Button style={styles.button}>
                {this.state.category == 'All' ? t('Category') : this.state.category} <Icon type="down" />
              </Button>
            </Dropdown>
            <Dropdown disabled={this.state.category == 'All'} overlay={this.menuCluster()}>
              <Button style={styles.button}>
                {this.state.cluster == 'All' ? t('Cluster') : this.state.cluster} <Icon type="down" />
              </Button>
            </Dropdown>
            {/*
            <Dropdown disabled={this.state.cluster == 'All' || this.state.category == 'All' } overlay={this.menuSkill()}>
              <Button style={styles.button}>
                {this.state.skill == 'All' ? t('Skills') : this.state.skill} <Icon type="down" />
              </Button>
            </Dropdown>
            */}
          </div>
          <GraphSkillsLogged t={this.props.t} data={this.props.skillslogged} />
        </div>
        <div id='amountskills' style={styles.container3}>
          <CompareTool 
            t={this.props.t} 
            allLogs={this.props.allLogs} 
            allStudents={this.props.allStudents} 
            allYears={this.props.allYears}
            classes={this.props.classes} 
            currentYear={this.props.currentYear}
            categories={this.props.category}
            clusters={this.props.allClusters}
          />
        </div>
      </div>
    )
  }
}

export default GeneralInfoRender;

const styles = {

  logged: {
    fontSize: '24px',
    color: 'white',
    fontWeight: 600,
    textAlign: 'center',
    lineHeight: '33px',
    height: '220px',
    width: '220px',
    borderRadius: '50%',
    backgroundColor: '#4A90E2',
    marginLeft: 20,
    marginRight: 20,
    paddingTop: 45,
    boxShadow: '0 6px 16px 0 rgba(0,77,182,0.38)',
    display: 'inline-block'
  },
  yearbox: {
    backgroundColor: 'white',
    padding: '40px 20px'
  },

  chartholder: {
    width: 'auto',
    maxWidth: 500
  },

  container: {
    margin: '0px 20px 20px 20px'
  },

  container2: {
    margin: '20px',
    backgroundColor: 'white',
    padding: '40px',
    height: 530
  },
  container3: {
    margin: '20px',
    backgroundColor: 'white',
    padding: '40px',
    height: 660
  },

  button: {
    borderRadius: '25px',
    width: '195px',
    marginRight: '20px',
  },

  dropdown: {
    width: '285px',
    padding: '20px'
  },

  paragraph: {
    fontSize: '16px',
    marginBottom: '20px',
    marginLeft: '40px'
  }
}



// WEBPACK FOOTER //
// ./src/components/GeneralInfoRender/index.jsx